module.exports = __webpack_public_path__ + "img/sibi_1kl.5152a5f4.jpg";